/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Run_Retry_QueuedInputs */

const en_automation_run_retry_queued = /** @type {(inputs: Automation_Run_Retry_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run queued for retry.`)
};

const pt_br2_automation_run_retry_queued = /** @type {(inputs: Automation_Run_Retry_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execução enviada para nova tentativa.`)
};

/**
* | output |
* | --- |
* | "Run queued for retry." |
*
* @param {Automation_Run_Retry_QueuedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_run_retry_queued = /** @type {((inputs?: Automation_Run_Retry_QueuedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Run_Retry_QueuedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_run_retry_queued(inputs)
	return pt_br2_automation_run_retry_queued(inputs)
});